const lang = localStorage.getItem('lang')

export default {
  state: lang ? { language: lang } : { language: 'ru' },
  mutations: {
    setLanguage (state, value) {
      state.language = value
      localStorage.setItem('lang', value)
    }
  },
  actions: {
    setRuLanguage ({ commit }) {
      commit('setLanguage', 'ru')
    },
    setEnLanguage ({ commit }) {
      commit('setLanguage', 'en')
    }
  },
  getters: {
    language (state) {
      return state.language
    }
  }
}
